import React from 'react'

import './SmallPill.scss'
import classNames from 'classnames'

export const SmallPill = (props: {
  className?: string
  children?: React.ReactNode
  isInverse?: boolean
}) => {
  const { children, className, isInverse } = props

  return (
    <span className={classNames('SmallPill', className, { isInverse })}>
      {children}
    </span>
  )
}